import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64, isColor } from "@/utils";

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "N5gPU5c15a",
        width: 58.025196850393705,
        height: 54.287979002624674,
        left: 8.303832020997376,
        top: 477.554750656168,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "X1qvSpFfUu",
        width: 820.500997375328,
        height: 57.5,
        left: 90.02887139107611,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: 微软雅黑;">${
          node.title || ""
        }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "3l_Q3SWCDM",
        width: 242.9476115485564,
        height: 40.75,
        left: 74.27963961859523,
        top: 236.49787385353096,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 16.75px;font-family: 微软雅黑;font-weight: bold;">${
          node.children[0].title || ""
        }</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "E3td1e64lT",
        width: 246.72293963254594,
        height: 60,
        left: 80.77853725639049,
        top: 291.77598408975143,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 14.9375px;font-family: 微软雅黑;">${node.children[0].text}</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "ByDihQ9l-D",
        width: 242.9476115485564,
        height: 40.75,
        left: 371.392395524107,
        top: 236.49787385353096,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 16.75px;font-family: 微软雅黑;font-weight: bold;">${
          node.children[1].title || ""
        }</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "RtigZ3U9wf",
        width: 246.72293963254594,
        height: 80,
        left: 383.0609236638992,
        top: 291.77598408975143,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 14.9375px;"><span style="font-family: 微软雅黑;">${node.children[1].text}</span></span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "nEiADj1uGR",
        width: 242.9476115485564,
        height: 40.75,
        left: 668.5050464427422,
        top: 236.49787385353096,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 16.75px;font-family: 微软雅黑;font-weight: bold;">${
          node.children[2].title || ""
        }</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "Aji74Ery4k",
        width: 246.72293963254594,
        height: 100,
        left: 679.0984181241868,
        top: 291.77598408975143,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 14.9375px;font-family: 微软雅黑;">${node.children[2].text}</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "3zN1VSykGc",
        width: 94.79947506561679,
        height: 66.875,
        left: 146.4660963115086,
        top: 114.03057726560445,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 46.875px;font-family: 微软雅黑;font-weight: bold;">01</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "Avph78iACM",
        width: 94.79947506561679,
        height: 66.875,
        left: 440.5787472301438,
        top: 114.03057726560445,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 46.875px;font-family: 微软雅黑;font-weight: bold;">02</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "text",
        id: "O7wDeMJzDP",
        width: 94.79947506561679,
        height: 66.875,
        left: 738.2674611409047,
        top: 114.03057726560445,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content: `<p style="text-align: center;"><span style="font-size: 46.875px;font-family: 微软雅黑;font-weight: bold;">03</span></p>`,
        lineHeight: 1,

        fill: "",
      },
      {
        type: "shape",
        id: "Mtb2x-NLtj",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 29.14288713910761,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_YOLU_rWfG",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 28.900997375328085,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "QTLV2900Fg",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 29.041784776902887,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "lg8Nynlunm",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 29.77742782152231,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "f-CAtpb_El",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 29.438530183727035,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "3KkgIK2dvx",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 38.80283464566929,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "JM6pTvmum4",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 38.560839895013125,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_fP69ZGxf8",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 38.70162729658793,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "vxA5euaU5g",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 39.43737532808399,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "rUjOsYzZTv",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 39.098372703412075,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "NVedvC2Fmz",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 48.462782152230965,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "cwmid3pRoS",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 48.220787401574796,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "9rL9Hu6-cX",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 48.36157480314961,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "VE5ASVaTjq",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 49.09732283464567,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "K4hV9NTBo6",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 48.75832020997375,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "zBY1uUIndJ",
        width: 6.901837270341207,
        height: 6.901837270341207,
        left: 37.31653543307087,
        top: 58.122624671916014,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "h4vKVGvTzu",
        width: 6.408818897637795,
        height: 6.408818897637795,
        left: 47.166089238845146,
        top: 57.88073490813648,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Fn4uiagPlY",
        width: 6.127349081364829,
        height: 6.127349081364829,
        left: 56.52272965879265,
        top: 58.02152230971128,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Htf5Q1bqUK",
        width: 5.678950131233596,
        height: 5.678950131233596,
        left: 65.59779527559056,
        top: 58.75727034120735,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PViMbcPnvM",
        width: 5.3800524934383205,
        height: 5.3800524934383205,
        left: 74.22446194225721,
        top: 58.41826771653543,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "6XKpK37Ezm",
        width: 250.0251968503937,
        height: 233.92199475065615,
        left: 797.1127559055118,
        top: -130.44125984251968,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,

        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "UJrgSxmbdw",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 106.42620129838525,
        top: 192.477716373216,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "ak1KKEUpaL",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 106.42620129838525,
        top: 179.53566912912152,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.7,
      },
      {
        type: "shape",
        id: "GYvA0pnO9_",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 403.5894033981228,
        top: 192.477716373216,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "uGrTHH-VEF",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 403.5894033981228,
        top: 179.53566912912152,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.7,
      },
      {
        type: "shape",
        id: "RsvRqchrY1",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 702.5392196710886,
        top: 193.84762450969893,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "P7uWQRl1AK",
        width: 174.87926509186352,
        height: 31.884094488188975,
        left: 702.5392196710886,
        top: 180.90557726560445,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}45`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        gradient: {
          type: "linear",
          rotate: 75,
          color: ["rgba(244,247,255,1)", `${color}`],
        },
        opacity: 0.7,
      },
    ],
    background,
  };
};

export default nodule;
